































import Vue from 'vue'
import NewMonthList from '../molecules/NewMonthList.vue'
import NewMonthTitle from '../molecules/NewMonthTitle.vue'
import SubjectButton from '../molecules/SubjectButton.vue'
import NoContentsMessage from '../molecules/NoContentsMessage.vue'
import { ManabiContent } from '@/types/ManabiContent'

export default Vue.extend({
  components: {
    NewMonthList,
    NewMonthTitle,
    SubjectButton,
    NoContentsMessage
  },
  props: {
    contents: {
      type: Object,
      required: true
    },
    subjects: {
      type: Array,
      default: null
    },
  },
  computed: {
    month(): number | null {
      return this.$store.state.month
    },
    filteredContents(
      this: {
        $store: {
          state: {
            year: number | null,
            month: number | null,
            contents: Record<string, { contents: ManabiContent[] }>
          }
        }
      }
    ): ManabiContent[] {
      if (!this.$store.state.year || !this.$store.state.month) return []
      const key =
        this.$store.state.year.toString() +
        ('0' + this.$store.state.month).slice(-2)
      const data = this.$store.state.contents[key]
      return data ? data.contents : []
    }
  }
})
